/**
 * Payment Fees — the admin screen behind the pass-through switch.
 *
 * Staff may read the policy here; only a SUPER administrator can change it, which
 * is enforced server-side as well as by the disabled inputs. Saved changes take
 * effect within about a minute everywhere (the setting caches in
 * services/payments/settingCache.js), and every change is written to the audit
 * log with the reason given.
 */

import React from "react";
import PaymentFeePolicyPanel from "../components/money/PaymentFeePolicyPanel";

/* Who may change it comes from the Settings page (`canEdit`, the "manage"
   level from GET /api/platform-settings/access), the same rule the server's
   requireSettingsAccess("manage") applies. It used to be read from the role in
   browser storage, which showed a settings:manage holder a read-only page. */
const PaymentFeeSettings = ({ canEdit = false }) => (
  <div className="content">
    <PaymentFeePolicyPanel canEdit={canEdit} />
  </div>
);

export default PaymentFeeSettings;
